module.exports = __webpack_public_path__ + "img/google_icon.fecc2c88.svg";